import {BaseFormModel} from './base-form-model';

export class TaxReportSummary extends BaseFormModel<TaxReportSummary> {
    name: string;
    total: number;
}
